import { PayloadAction } from '@reduxjs/toolkit';

import { IConceptIDOverlaps, IDataSet, IMappingState } from './mapping.interface';
import { ISelectedMappingNoQuery } from './properties.interface';
import { getFormDefaultsFromOverlaps } from './helpers';
import { mappingDefBase } from './initialState';

type TPayloadAction = {
  conceptIdOverlaps: IConceptIDOverlaps[];
  dataSetMap: Record<number, IDataSet>;
};

export const updateConceptIdOverlapsSlice = {
  setConceptIdOverlaps: (state: IMappingState, action: PayloadAction<TPayloadAction>) => {
    let formDefaultValues: Pick<
      ISelectedMappingNoQuery,
      'idColumnName' | 'mappingIdTypeId' | 'idFunction'
    > = getFormDefaultsFromOverlaps(
      action.payload.conceptIdOverlaps,
      action.payload.dataSetMap || {},
      state.selectedMapping || mappingDefBase
    );

    // pre-populate defaults for conceptId idColumnName & idFunction
    // if un-mapped property has overlaps for this conceptUri
    if (action.payload.conceptIdOverlaps.length > 0 && state.selectedMapping?.id === null) {
      state.selectedMapping.idColumnName = formDefaultValues.idColumnName;
      state.selectedMapping.mappingIdTypeId = formDefaultValues.mappingIdTypeId;
      state.selectedMapping.idFunction = formDefaultValues.idFunction;
    }
  },
};
